<template>
  <div class="search-bar mb-4">
    <div class="input-group">
      <span class="input-group-text bg-white">
        <i class="bi bi-search"></i>
      </span>
      <input
        type="text"
        class="form-control"
        placeholder="Search posts by title, content, or tags..."
        :value="searchQuery"
        @input="$emit('update:searchQuery', $event.target.value)"
      >
      <button
        v-if="searchQuery"
        class="btn btn-outline-secondary"
        type="button"
        @click="$emit('clear')"
      >
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div v-if="searchQuery" class="search-results-info mt-2">
      <small class="text-muted">
        Found {{ resultsCount }} post{{ resultsCount !== 1 ? 's' : '' }} matching "{{ searchQuery }}"
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  props: {
    searchQuery: {
      type: String,
      required: true
    },
    resultsCount: {
      type: Number,
      required: true
    }
  },
  emits: ['update:searchQuery', 'clear']
}
</script>

<style scoped>
.search-bar {
  background: white;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.search-bar .input-group-text {
  border-right: none;
  color: #667eea;
}

.search-bar .form-control {
  border-left: none;
  border-right: none;
}

.search-bar .form-control:focus {
  box-shadow: none;
  border-color: #ced4da;
}

.search-results-info {
  padding-left: 0.5rem;
}
</style>
